import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { Provider } from "react-redux";
import { Integrations } from "@sentry/tracing";
import "./antd.css";
import "./index.css";
import App from "./app";
import { store } from "./store";
import reportWebVitals from "./reportWebVitals";
import "./http";

const environment = window.location.hostname === "localhost" ? "development" : "production";

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  environment: environment,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

function FallbackComponent() {
  return <div>An error has occurred</div>;
}

const myFallback = <FallbackComponent />;
// Alternatively:
// const myFallback = () => <FallbackComponent />;

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <Sentry.ErrorBoundary fallback={myFallback} showDialog>
    <Provider store={store}>
      <App />
    </Provider>
  </Sentry.ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
